const routes = [
  {
    path: '/piyao/pctips',
    name: 'piyao-pctips', // PC端辟谣发布
    meta: {
      title: 'PC端辟谣发布',
    },
    component: () => import('@/views/piyao/PctipsPage.vue'),
  },
];
export default routes;
